import groq from 'groq';
import { defaultLocale } from '@pkg/config/languages';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const blockCareersFields = groq`
  ...,
  description[] {${portableTextWithReferences}},
  "defaultResultsLabels": *[_id == "singleton-careerPages-${defaultLocale}-careers-home" && language == "${defaultLocale}"]{
  content[][_type == "modularContentBlocks.outer.careers"] {resultsLabels}
  }
`;
